import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBH5w89QskrzYsSU-f8b-fNCliQ8KcbIIQ",
  authDomain: "linguaswipe-4e39f.firebaseapp.com",
  projectId: "linguaswipe-4e39f",
  storageBucket: "linguaswipe-4e39f.firebasestorage.app",
  messagingSenderId: "607822387916",
  appId: "1:607822387916:web:d3a7e7c84fce1281f1c069"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export default app;
